import { render, staticRenderFns } from "./mainView.vue?vue&type=template&id=6df84dc2&"
import script from "./mainView.vue?vue&type=script&lang=js&"
export * from "./mainView.vue?vue&type=script&lang=js&"
import style0 from "./mainView.vue?vue&type=style&index=0&id=6df84dc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports